/**
 * BaseComponent - Abstract base class for all components
 * Provides common functionality and lifecycle management
 */
export class BaseComponent {
    constructor(selector, options = {}) {
        this.selector = selector;
        this.element = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.options = options;
        this.initialized = false;
    }

    /**
     * Check if component element exists in DOM
     */
    exists() {
        return this.element !== null;
    }

    /**
     * Initialize the component
     * Override this method in child classes
     */
    init() {
        if (this.initialized) {
            console.warn(`Component ${this.constructor.name} already initialized`);
            return;
        }
        
        if (!this.exists()) {
            console.warn(`Element not found for ${this.constructor.name}`);
            return;
        }

        this.initialized = true;
        return this;
    }

    /**
     * Destroy the component and cleanup event listeners
     * Override this method in child classes
     */
    destroy() {
        this.initialized = false;
        return this;
    }

    /**
     * Query selector within component element
     */
    $(selector) {
        return this.element ? this.element.querySelector(selector) : null;
    }

    /**
     * Query selector all within component element
     */
    $$(selector) {
        return this.element ? this.element.querySelectorAll(selector) : [];
    }
}

